import React from 'react';

import styles from './styled-project-components.module.scss';
export const ScreenContainer = ({ className, ...props }: React.ComponentPropsWithoutRef<'div'>) => (
  <div
    className={
      className ? `${styles['screen-container']} ${className}` : styles['screen-container']
    }
    {...props}
  />
);
